import { createStore } from 'vuex';
import { DISPLAY_MAINTENANCE_MODE, SET_CURRENT_USER, SET_TOAST } from '@/store/mutations.type';
import {
  FETCH_CURRENT_USER,
  HIDE_MAINTENANCE_MODAL,
  REMOVE_CURRENT_USER,
  SHOW_MAINTENANCE_MODAL,
  SET_TOAST as SET_TOAST_ACTION
} from '@/store/actions.type';
import { UserService } from '@/services';
import { User } from '@/types';

export interface State {
  isMaintenanceModalVisible: boolean;
  currentUser: User | null;
  toast: HTMLIonToastElement | null;
}

export const store = createStore<State>({
  state() {
    return {
      isMaintenanceModalVisible: false,
      currentUser: null,
      toast: null
    };
  },
  mutations: {
    [DISPLAY_MAINTENANCE_MODE](state, value) {
      state.isMaintenanceModalVisible = value;
    },
    [SET_CURRENT_USER](state, user: User | null) {
      state.currentUser = user;
    },
    [SET_TOAST](state, toast: HTMLIonToastElement | null) {
      state.toast = toast;
    }
  },

  actions: {
    [SHOW_MAINTENANCE_MODAL](context) {
      context.commit(DISPLAY_MAINTENANCE_MODE, true);
    },
    [HIDE_MAINTENANCE_MODAL](context) {
      context.commit(DISPLAY_MAINTENANCE_MODE, false);
    },
    [REMOVE_CURRENT_USER]({ commit }) {
      commit(SET_CURRENT_USER, null);
    },
    async [FETCH_CURRENT_USER]({ commit }) {
      try {
        const userService = new UserService();
        const user = await userService.get();
        commit(SET_CURRENT_USER, user);
      } catch (e) {
        console.error(e);
      }
    },
    [SET_TOAST_ACTION]({ commit }, toast: HTMLIonToastElement | null) {
      commit(SET_TOAST, toast);
    }
  }
});
